export default __webpack_public_path__ + "static/process-01-bc334857aa98472beb3647147ddb95d9.svg";